import { render } from "./ChoixTemplateProjet.vue?vue&type=template&id=6234e4a7&scoped=true"
import script from "./ChoixTemplateProjet.vue?vue&type=script&lang=ts"
export * from "./ChoixTemplateProjet.vue?vue&type=script&lang=ts"

import "./ChoixTemplateProjet.vue?vue&type=style&index=0&id=6234e4a7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6234e4a7"

export default script